import { clientSideSupabase } from "../xmsSupabase";
import { createEventString, log } from "../log";
import { definitions } from "../../types/supabase";
import getErrorMessage from "../getErrorMessage";

const getRedirectUrl = async (
  email: string,
  needsToken: boolean,
  brandId: string
) => {
  try {
    const { learning_domain: url } = clientSideSupabase.ensureOne<
      definitions["brands"]
    >(
      await clientSideSupabase.supabase
        .from("brands")
        .select("learning_domain")
        .eq("id", brandId)
    );
    let redirectUrl = url!;

    const response = await fetch("/api/user/getRedirectUrl/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        needsToken,
        url,
      }),
    });

    if (response.ok) {
      const responseJson = await response.json();
      redirectUrl = responseJson.redirectUrl;
    }

    return redirectUrl;
  } catch (error) {
    const message = getErrorMessage(error);
    log({
      eventName: createEventString("modal", "error", "get_redirect_url"),
      eventMessage: "Unable to get the redirect url",
      eventData: {
        brand_id: brandId,
        email,
        error,
        error_message: message,
        needs_token: needsToken,
      },
      eventLevel: "error",
    });
  }
};

export default getRedirectUrl;
